import { useRef } from 'react';
export const useConstant = (getValue) => {
    const value = useRef();
    if (!value.current) {
        value.current = { v: getValue() };
    }
    return value.current.v;
};
export default useConstant;
